import { all, fork } from 'redux-saga/effects';

import inventorySaga from './inventory/inventory.saga';
import locationsSaga from './locations/locations.saga';
import newShipmentSaga from './newShipment/newShipment.saga';
import packagesSaga from './packages/packages.saga';
import reportsSaga from './reports/reports.saga';
import shipmentsSaga from './shipments/shipments.saga';
import stoneLookupSaga from './stoneLookup/stoneLookup.saga';
import suppliersSaga from './suppliers/suppliers.saga';
import trackingSaga from './tracking/tracking.saga';
import { metaSaga } from './meta';

export function* stoneSaga() {
  yield all([
    fork(inventorySaga),
    fork(metaSaga),
    fork(shipmentsSaga),
    fork(newShipmentSaga),
    fork(packagesSaga),
    fork(locationsSaga),
    fork(suppliersSaga),
    fork(reportsSaga),
    fork(trackingSaga),
    fork(stoneLookupSaga),
  ]);
}
